import React from 'react';
import styled from 'styled-components';
import Desktop from '../images/desktop.png';
import ResponsiveImg from '../components/ResponsiveImg';

const CompareMoviesDemo = styled.figure`
  background-image: url(${Desktop});
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0;
  padding-bottom: 85%;
  position: relative;

  img {
    width: 100%;
    left: 50%;
    position: absolute;
    top: 4.25%;
    transform: translateX(-50%);
    width: 92%;
  }
`;

export default ({ image, ...otherProps }) => (
  <CompareMoviesDemo>
    <img src={image} {...otherProps} />
  </CompareMoviesDemo>
);



// WEBPACK FOOTER //
// ./src/components/DemoInsideMac.js